import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 系统数字资产属性列表
export const setDigitalAttrs: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 已发布数字资产属性列表
export const setDigitalPublishedAttrs: Mutation<IModuleState> = (state, payload) => {
  state.publishedList.data = payload.data;
  state.publishedList.pageNum = payload.pageNum;
  state.publishedList.pageSize = payload.pageSize;
  state.publishedList.total = payload.total;
  state.publishedList.loading = !!payload.loading;
};

// 数字资产属性详情
export const setDigitalAttrDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 数字资产属性变更日志
export const setDigitalAttrLogs: Mutation<IModuleState> = (state, payload) => {
  state.logs.data = payload.data;
  state.logs.pageNum = payload.pageNum;
  state.logs.pageSize = payload.pageSize;
  state.logs.total = payload.total;
  state.logs.loading = !!payload.loading;
};

// 数字资产属性类型
export const setDigitalAttrTypes: Mutation<IModuleState> = (state, payload) => {
  state.attrTypes.data = payload.data;
  state.attrTypes.loading = !!payload.loading;
};

// 编码是否重复
export const setDigitalAttrExisted: Mutation<IModuleState> = (state, payload) => {
  state.existed.data = payload.data;
  state.existed.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.data = payload.data;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
